import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import styles from '../shared/styles';
import Smartuploader from '../../../../components/Smartuploader';
import { DivisionLabel, UploaderActionButtons } from '../shared/styled-components';
import Audioplayback from './Audioplayback';

class AudioEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUploader: false,
    };
  }

  renderContent() {
    const {
      original,
      edited,
      published,
      publicEpisode,
      episodeId,
      onUploadStart,
      onUploadComplete,
      onUploadRemove,
      onUploadError,
    } = this.props;

    if (!this.state.showUploader) {
      return (
        <AudioEditWrapper>
          <div className="AudioUpload-container">
            <Audioplayback
              original={original}
              edited={edited}
              published={published}
              publicEpisode={publicEpisode}
            />

            <UploaderActionButtons className={'UploaderActionButtons'}>
              <div className="action-buttons">
                <div className="icon-button">
                  <span
                    className="material-icons"
                    onClick={() => {
                      this.setState({ showUploader: true });
                    }}
                    title="Edit">
                    edit
                  </span>
                </div>
              </div>
            </UploaderActionButtons>
          </div>
        </AudioEditWrapper>
      );
    } else {
      return (
        <Smartuploader
          header={
            <React.Fragment>
              <span style={styles.miniSubheaderText}>
                (mp3, mp4, m4a, wav and mov files accepted)
              </span>
            </React.Fragment>
          }
          fileuploader={{
            server: '/api/uploadv2',
            onaddfilestart: onUploadStart,
            onprocessfile: onUploadComplete,
            onremovefile: () => {
              this.setState({ showUploader: false });
              onUploadRemove();
            },
            onerror: onUploadError,
            acceptedFileTypes: [
              'audio/mpeg',
              'video/mp4',
              'audio/x-m4a',
              'audio/wav',
              'video/quicktime',
            ],
            fileValidateTypeLabelExpectedTypesMap: {
              'audio/mpeg': '.mp3',
              'video/mp4': '.mp4',
              'audio/x-m4a': '.m4a',
              'audio/wav': '.wav',
              'video/quicktime': '.mov',
            },
            fileRenameFunction: file => {
              return `${episodeId}${file.extension}`;
            },
            fileMetadataObject: {
              episodeId,
              filerename: episodeId + '-updated',
              episodePropKey: 'updatedUrl',
              importingAudio: true,
              hasUpdatedAudio: true,
            },
          }}
          linkuploader={{
            server: '/api/uploadv2',
            onimportstart: onUploadStart,
            onimportcomplete: onUploadComplete,
            onimportremove: () => {
              this.setState({ showUploader: false });
              onUploadRemove();
            },
            onimporterror: onUploadError,
            metadataObject: {
              episodeId,
              filerename: episodeId + '-updated',
              episodePropKey: 'updatedUrl',
              importingAudio: true,
              hasUpdatedAudio: true,
            },
          }}
        />
      );
    }
  }

  render() {
    return (
      <div className="row" style={styles.rowDivision}>
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel>Track audio</DivisionLabel>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

const AudioEditWrapper = styled.div`
  .AudioUpload-container {
    height: 230px;
    overflow: hidden;
    position: relative;
    margin-top: -20px;
    .UploaderActionButtons {
      width: calc(37.5% - 19px) !important;
      border-radius: 0 0 10px 10px;
    }
  }

  &&& img {
    width: 100%;
    height: 100%;
  }
`;

AudioEdit.propTypes = {
  episodeId: PropTypes.string,
  onUploadStart: PropTypes.func,
  onUploadComplete: PropTypes.func,
  onUploadRemove: PropTypes.func,
  onUploadError: PropTypes.func,
};

AudioEdit.defaultProps = {
  episodeId: '',
  onUploadStart: () => {},
  onUploadComplete: () => {},
  onUploadRemove: () => {},
  onUploadError: () => {},
};

export default AudioEdit;
